import coffeeWarmerImg from "../assets/images/products/coffee-warmer.png";
import stovetopEspressoImg from "../assets/images/products/Stovetop-Espresso-Maker.png";
import traditionalFilterImg from "../assets/images/products/Traditional-coffee-filter.png";
import coffeeMugImg from "../assets/images/products/coffee-Mug.jpg";

export const COFFEE_GEAR_PRODUCTS = {
  401: {
    _id: 401,
    id: 401,
    productName: "Traditional South Indian Coffee Filter",
    price: 399,
    images: [traditionalFilterImg],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    productDescription: `<p>Bring home the rich heritage of South Indian coffee brewing with our Traditional South Indian Coffee Filter. Designed to perfectly brew the famous filter coffee (also known as KAAPI), this elegant yet practical coffee filter promises a full-bodied and aromatic cup every time.</p>
<p>Made from high-quality stainless steel, this filter is durable, rust-resistant, and built to last, ensuring a pure brew with no metallic taste. Brew coffee the authentic way with the two-chamber filter system. Water slowly drips through the ground coffee, extracting maximum flavor and aroma for a perfectly balanced cup.</p>
<p>Add your favorite South Indian coffee powder in the top chamber, pour hot water, and let the slow-drip process work its magic. In just minutes, you'll have the strong, aromatic coffee decoction ready to be mixed with hot milk. This coffee filter is designed to extract the rich, strong flavors that South Indian coffee is known for, giving you a smooth and satisfying brew.</p>
<p>Get the perfect coffee decoction that's rich, strong, and brimming with flavor. Whether you enjoy your coffee strong or mild, this filter allows you to control the brewing process to suit your taste. It's great for making traditional kaapi, as well as other strong coffee decoctions. Our traditional coffee filter is reusable, making it an eco-friendly option for daily coffee brewing.</p>
<p><strong>Order today and immerse yourself in the authentic taste of South Indian filter coffee!</strong></p>`,
  },
  402: {
    _id: 402,
    id: 402,
    productName: "Stovetop Espresso Maker",
    price: 799,
    images: [stovetopEspressoImg],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    gram: "Makes 6 cups",
    productDescription: `<p>Unleash the Power of Fresh Espresso with our Stovetop Espresso Machine. Brew authentic, rich, and aromatic espresso right in the comfort of your home. Designed for true coffee enthusiasts, this classic espresso maker ensures that every cup you make is full of flavor and deep aroma. This espresso maker extracts the full flavor of your coffee beans, ensuring a smooth shot. Crafted from durable, high-quality stainless steel, this espresso machine is lightweight yet sturdy, providing excellent heat distribution for consistent brewing.</p>
<p>Just add water to the base, fill the filter with your favorite ground coffee, and place it on your stovetop. In minutes, you'll hear the espresso bubbling and ready to serve!</p>
<p>Suitable for gas, electric, and ceramic stovetops, it gives you the flexibility to brew at home, on a camping trip, or even at work. Perfect for small kitchens, RVs, or travel, it's easy to store and lightweight enough to take on the go.</p>
<p><strong>Order now and taste the difference in every cup!</strong></p>`,
  },
  403: {
    _id: 403,
    id: 403,
    productName: "Coffee Warmer",
    price: 499,
    images: [coffeeWarmerImg],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    productDescription: `<p>Our Coffee Warmer is the perfect companion for keeping your brew at the ideal temperature, ensuring every sip is as warm and enjoyable as the first. This compact and stylish warmer helps you savor every drop of your coffee. Crafted from high-quality stainless steel, this coffee warmer is durable, resistant to rust, and designed to distribute heat evenly for consistent warmth. The sleek, lightweight design makes it easy to carry and store.</p>
<p><strong>Order now and keep the warmth in every cup!</strong></p>`,
  },
  404: {
    _id: 404,
    id: 404,
    productName: "Coffee Mug",
    price: 299,
    images: [coffeeMugImg],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    gram: "180 ml",
    productDescription: `<p>Sip in style and comfort with our premium coffee mugs, specially crafted to elevate every moment of your daily routine. Made from high-quality, durable ceramic, these mugs keep your drink at the perfect temperature while fitting comfortably in your hand.</p>
<p>Ideal for coffee, our mugs are perfect for cozy mornings, office breaks, or gifting to loved ones who appreciate a good brew.</p>
<p><strong>Start every day with a smile and the perfect cup.</strong></p>`,
  },
};

export function getCoffeeGearProduct(id) {
  return COFFEE_GEAR_PRODUCTS[id];
}
